import React from "react";
import { Link } from "react-router-dom";
import AOS from "aos";

const NotFound = () => {
  React.useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <div 
      className="d-flex flex-column justify-content-center align-items-center min-vh-100 text-center"
      data-aos="fade-up"
    >
      <h1 className="display-3 text-danger">404</h1>
      <p className="lead">الصفحة غير موجودة</p>
      <Link to="/" className="btn btn-primary mt-3">
        العودة إلى الصفحة الرئيسية
      </Link>
    </div>
  );
};

export default NotFound;
